import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractInput } from '../abstract-input';

@Component({
	selector: 'spaq-input-textarea',
	template: `
		<kendo-formfield>
			<kendo-label [for]="formControlName" [text]="label"></kendo-label>
			<textarea
				[name]="formControlName"
				[id]="formControlName"
				[attr.data-testid]="dataTestId"
				[disabled]="disabled"
				kendoTextArea
				[(ngModel)]="value"
				(ngModelChange)="updateModel()"
				(blur)="onModelTouched && onModelTouched()"
			></textarea>

			<div *ngIf="!isValid">
				<small class="alert-danger" *ngIf="control.hasError('required')">Champ requis</small>
			</div>
		</kendo-formfield>
	`,
	styles: [],
	providers: [
		{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InputTextareaComponent), multi: true },
		{ provide: NG_VALIDATORS, useExisting: forwardRef(() => InputTextareaComponent), multi: true }
	]
})
export class InputTextareaComponent extends AbstractInput {
	@Input() label = '';
}
